import React from 'react'
import { object } from 'prop-types'
import Table from 'react-bootstrap/lib/Table'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

const BillingDetails = ({ data }) => (
  <form className="grid-form">
    <Fieldset legend="Assessment of Fees">
      <Table condensed>
        <thead>
          <tr>
            <th width="80%">Fee</th>
            <th width="20%" className="text-right">Amount (Php)</th>
          </tr>
        </thead>
        <tbody>
          {data.get('reg_billing').map((item, k) => (
            <tr key={k}>
              <td>{item.get('fee_name')}</td>
              <td className="text-right">{acc.formatNumber(item.get('amount'), 2)}</td>
            </tr>
          ))}
          <tr>
            <td>Miscellaneous Fees</td>
            <td className="text-right">{acc.formatNumber(data.getIn(['meta', 'total_misc']), 2)}</td>
          </tr>
          {!!data.get('misc_billing') &&
            <tr>
              <td>
                <Table condensed className="table--inner">
                  <thead>
                    <tr>
                      <th colSpan="2">Miscellaneous Breakdown</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.get('misc_billing').map((item, k) => (
                      <tr key={k}>
                        <td>{item.get('fee_name')}</td>
                        <td className="text-right">{acc.formatNumber(item.get('amount'), 2)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td className="text-right">Total Misc:</td>
                      <td className="text-right">{acc.formatNumber(data.getIn(['meta', 'total_misc']), 2)}</td>
                    </tr>
                  </tbody>
                </Table>
              </td>
              <td></td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <th className="text-right">Total Billing:</th>
            <th className="text-right">{acc.formatNumber(data.getIn(['meta', 'total_amount']), 2)}</th>
          </tr>
        </tfoot>
      </Table>
    </Fieldset>
  </form>
)

BillingDetails.propTypes = {
  data: object,
}

export default BillingDetails



// WEBPACK FOOTER //
// ./src/containers/Billing/billing-details.js